import './Contact.scss'

export default function Contact() {
  // const [message,setMessage] = useState(null)

  // Handle Form Submit
  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   setMessage(true)
  // }

  const socials = [
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/fpyc/',
      logo: '/assets/logos/linkedin-logo.png',
    },
    {
      name: 'github',
      url: 'https://github.com/mocha-maker/',
      logo: '/assets/logos/github-logo.png',
    },
    // {
    //   name: "behance",
    //   url: "https://www.linkedin.com/in/fpyc/",
    //   logo: "/assets/logos/behance-logo.png",
    // },
  ]

  return (
    <div className='contact' id='contact'>
      <h1>Get in touch</h1>
      <div className='container'>
        <div className='left'>
          <h3>Call</h3>
          <span>
            <a href='tel:+15162809388'>516.820.9388</a>
          </span>

          <h3>Email</h3>
          <span>
            <a href='mailto:flynn.pyc@gmail.com'>flynn.pyc@gmail.com</a>
          </span>

          <h3>Connect</h3>
          <div className='socialsContainer'>
            {socials.map((site) => (
              <a
                key={site.name}
                href={site.url}
                title={site.name}
                target='_blank'
                rel='noreferrer'
              >
                <img src={site.logo} alt={site.name} />
              </a>
            ))}
          </div>
          <a
            href='\assets\Resume_Flynn_2022.pdf'
            target='_blank'
            rel='noreferrer'
            className='button'
            alt='Download Resume'
          >
            Download Resume
          </a>
        </div>

        {/* <div className="right">
          <form onSubmit={handleSubmit} 
              action="mailto:flynn.pyc@gmail.com"
              method="POST"
              enctype="multipart/form-data">
            <input type="text" name="name" placeholder="Name"/>
            <input type="text" name="email" placeholder="Email"/>
            <textarea name="message" id="" placeholder="Message"></textarea>
            <button type="submit">Send</button>
            {message && <span>Thanks, I'll reply ASAP! </span>}
          </form>
        </div> */}
      </div>
    </div>
  )
}
